import { useState, useEffect, createContext } from 'react'
import dayjs from "dayjs"
import 'dayjs/locale/pt-br'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import { useAction, useFetchYoastSEOFocusKeyword } from '../../../api/actions/action'

const ContextChoose = createContext()

export function ContextChooseProvider({ children }) {
    dayjs.extend(localizedFormat)
    dayjs.locale('pt-br')

    const [rows, setRows] = useState([])
    const [rowsSelected, setRowsSelected] = useState([])
    const [rowsSelectedSave, setRowsSelectedSave] = useState([])
    const [typeSearch, setTypeSearch] = useState('title')
    const [searchValue, setSearchValue] = useState('')

    const { mutate: getDataPosts, data: dataPosts } = useAction()
    const { mutate: getAllFocuskwOpti, data: allFocuskwOpti } = useAction()
    const { mutate: getYoastkw, data: dataYoastKw } = useFetchYoastSEOFocusKeyword()

    const getKeyWords = (post, yoastSEOKw) => {
        const yoastKw = { kw: "" }
        const optiKw = { kw: "" }

        if (!allFocuskwOpti.success) optiKw.kw = ""
        else
            optiKw.kw = allFocuskwOpti.data.filter(x => parseInt(x.post_id) === parseInt(post.id))

        if (!yoastSEOKw.success) yoastKw.kw = ""
        else
            yoastKw.kw = yoastSEOKw.data.filter(x => parseInt(x.post_id) === parseInt(post.id))

        const rankMathKw = post?.metadata?.rank_math_focus_keyword ?? ""
        const seopressKw = post?.metadata?._seopress_analysis_target_kw ?? ""

        if (optiKw?.kw?.length > 0 && optiKw?.kw[0]?.meta_value !== "")
            return optiKw.kw[0]?.meta_value
        if (yoastKw?.kw?.length > 0 && yoastKw?.kw[0]?.meta_value !== "")
            return yoastKw.kw[0]?.meta_value
        if (rankMathKw !== "")
            return rankMathKw
        if (seopressKw !== "")
            return seopressKw

        return "sem palavra-chave"
    }

    useEffect(() => {
        getDataPosts('get_data_posts')
        getYoastkw()
        getAllFocuskwOpti('get_all_focuskw_opti')
    }, [])

    useEffect(() => {
        if (dataPosts !== undefined && dataYoastKw !== undefined && allFocuskwOpti !== undefined) {
            setRows(dataPosts?.data?.map(post => {
                return {
                    id: parseInt(post.id),
                    title: post.title,
                    keyword: getKeyWords(post, dataYoastKw),
                    postDateFormatted: dayjs(post.post_date).format('D [de] MMM [de] YYYY'),
                    categories: post.category,
                    tags: post.tags,
                    url: post.link,
                    html: "html",
                    slug: post.slug,
                    postDate: dayjs(post.post_date)
                }
            }))
        }
    }, [dataPosts, dataYoastKw, allFocuskwOpti])

    const contextValue = {
        rows,
        setRows,
        rowsSelected,
        setRowsSelected,
        typeSearch,
        setTypeSearch,
        searchValue,
        setSearchValue,
        rowsSelectedSave,
        setRowsSelectedSave
    }

    return (
        <ContextChoose.Provider value={contextValue}>
            {children}
        </ContextChoose.Provider>
    )
}

export default ContextChoose